/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plant_More_TreesInputs */

const en_plant_more_trees = /** @type {(inputs: Plant_More_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Earth just got a little greener, thanks to you.`)
};

const ar_plant_more_trees = /** @type {(inputs: Plant_More_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بفضلك، أصبح كوكب الأرض أكثر اخضراراً.`)
};

const de_plant_more_trees = /** @type {(inputs: Plant_More_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dank dir ist die Erde ein Stück grüner geworden.`)
};

const es_plant_more_trees = /** @type {(inputs: Plant_More_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Gracias a ti, la Tierra es un poco más verde!`)
};

const fr_plant_more_trees = /** @type {(inputs: Plant_More_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La Terre est un peu plus verte grâce à vous.`)
};

const it_plant_more_trees = /** @type {(inputs: Plant_More_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grazie a te, la Terra è diventata un po' più verde.`)
};

const ja_plant_more_trees = /** @type {(inputs: Plant_More_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのおかげで、地球がもう少し緑豊かになりました。`)
};

const ko_plant_more_trees = /** @type {(inputs: Plant_More_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`당신 덕분에 지구가 조금 더 푸르게 변했습니다.`)
};

const pt_br_plant_more_trees = /** @type {(inputs: Plant_More_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graças a você, a Terra ficou um pouco mais verde.`)
};

const ru_plant_more_trees = /** @type {(inputs: Plant_More_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Благодаря вам Земля стала чуточку зеленее.`)
};

const th_plant_more_trees = /** @type {(inputs: Plant_More_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โลกเขียวขจีขึ้นอีกนิดเพราะคุณ!`)
};

const tr_plant_more_trees = /** @type {(inputs: Plant_More_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sayende Dünya biraz daha yeşillendi.`)
};

const zh_cn_plant_more_trees = /** @type {(inputs: Plant_More_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`因为你，地球又多了更多树！`)
};

const zh_tw_plant_more_trees = /** @type {(inputs: Plant_More_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`因為你，地球又多了更多樹！`)
};

/**
* | output |
* | --- |
* | "The Earth just got a little greener, thanks to you." |
*
* @param {Plant_More_TreesInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const plant_more_trees = /** @type {((inputs?: Plant_More_TreesInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plant_More_TreesInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plant_more_trees(inputs)
	if (locale === "ar") return ar_plant_more_trees(inputs)
	if (locale === "de") return de_plant_more_trees(inputs)
	if (locale === "es") return es_plant_more_trees(inputs)
	if (locale === "fr") return fr_plant_more_trees(inputs)
	if (locale === "it") return it_plant_more_trees(inputs)
	if (locale === "ja") return ja_plant_more_trees(inputs)
	if (locale === "ko") return ko_plant_more_trees(inputs)
	if (locale === "pt_br") return pt_br_plant_more_trees(inputs)
	if (locale === "ru") return ru_plant_more_trees(inputs)
	if (locale === "th") return th_plant_more_trees(inputs)
	if (locale === "tr") return tr_plant_more_trees(inputs)
	if (locale === "zh_cn") return zh_cn_plant_more_trees(inputs)
	return zh_tw_plant_more_trees(inputs)
});